import { TrendingUp, TrendingDown, Bell, Sun, CalendarDays, Calendar, CalendarRange } from 'lucide-react';
import { CheckCircle2, Clock } from 'lucide-react';

const PERIOD_ICONS = { today: Sun, week: CalendarDays, month: Calendar, year: CalendarRange };

export default function PlatformStockHeader({ sym, name, tag, price, change, direction, periods = [] }) {
  const isUp = direction === 'up';

  return (
    <div className="plat-stock-hdr">
      <div className="psh-row1">
        <div>
          <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
            <span className="psh-sym">{sym}</span>
            <span className="psh-tag">{tag}</span>
          </div>
          <div className="psh-name">{name}</div>
        </div>
        <div style={{ textAlign: 'right' }}>
          <div className="psh-price">{price}</div>
          <div className={`psh-chg ${isUp ? 'up' : 'dn'}`}>
            {isUp ? <TrendingUp size={12} /> : <TrendingDown size={12} />}
            {change}
          </div>
        </div>
      </div>
      <div className="psh-row2">
        <div className="psh-periods">
          {periods.map((p, i) => {
            const Icon = PERIOD_ICONS[p.key] ?? Sun;
            return (
              <div key={i} className="period-mini">
                <div>
                  <div className="period-mini-lbl"><Icon size={9} /> {p.label}</div>
                  <div className="period-mini-range">{p.range}</div>
                </div>
                <span className={`badge ${p.verdict === 'hit' ? 'b-hit' : 'b-pend'}`}>
                  {p.verdict === 'hit' ? <CheckCircle2 size={9} /> : <Clock size={9} />}
                  {p.verdict === 'hit' ? 'Hit' : 'Pending'}
                </span>
              </div>
            );
          })}
        </div>
        <button className="psh-follow">
          <Bell size={12} /> Follow
        </button>
      </div>
    </div>
  );
}
